































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import CreateRepaymentPlanRequest from '@/models/Accounts/LendingAccounts/RepaymentPlans/CreateRepaymentPlanRequest';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import PlanLength from "@/models/Shared/PlanLength";
import ListUtils from '@/lib/listUtils';

@Component({ name: 'RepaymentPlanCreate' })
export default class extends SaascadaVueDialog {

    dialog = false;
    currentPage: number = 1;
    selectedTransaction: Transaction = null;
    request: CreateRepaymentPlanRequest = new CreateRepaymentPlanRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.currentPage = 1;
            this.selectedTransaction = null;
            this.request = new CreateRepaymentPlanRequest();
            // NOTE: Only gets the first page of transactions but should get all for dialog
            await LendingAccountModule.getLedgerTransactions({id: '', page: 1});
        }
    }

    @Watch('selectedTransaction')
    async onSelectedTransactionChanged(val: boolean) {
        if (val) {
            this.request.reference = this.selectedTransaction.transactionReference;
            this.request.totalRepaymentAmount.amount = this.selectedTransaction.amount.amount;
            this.request.totalRepaymentAmount.currency = this.selectedTransaction.amount.currency;
        }
    }

    get transactions() {
        // Filter to only debit transactions
        return LendingAccountModule.currentLendingAccountTransactions.filter((transaction) => {
            return transaction.debitCreditCode === 'DBIT';
        });
    }

    get planLengthOptions() {
        return ListUtils.planLengthOptions();
    }

    calculateMonthlyPayment() {
        const totalAmount = parseInt(this.selectedTransaction.amount.amount);
        const planLength = this.request.planLength;

        if (planLength === PlanLength.ThreeMonths) {
            return totalAmount / 3;
        }
        else if (planLength === PlanLength.SixMonths) {
            return totalAmount / 6;
        }
        else if (planLength === PlanLength.TwelveMonths) {
            return totalAmount / 12;
        }
        else {
            return totalAmount;
        }
    }

    async cancel() {
        this.dialog = false;
    }

    async back() {
        this.currentPage = this.currentPage - 1;
    }

    async next() {
        // Only calculate monthly payment after all fields are filled in
        this.request.monthlyPaymentAmount.amount = this.calculateMonthlyPayment() + "";
        this.request.monthlyPaymentAmount.currency = this.selectedTransaction.amount.currency;
        // Then move to the next page
        this.currentPage = this.currentPage + 1;
    }

    async create() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            await LendingAccountModule.createRepaymentPlan(this.request);
            //await LendingAccountModule.getRepaymentPlans(1);
        }
    }

}
